import { QUERY_PARAMS } from 'constants/queryNames';

export const getStAffAndOfferFromUrl = (urlValue?: string) => {
  if (!urlValue) {
    return null;
  }

  try {
    const url = new URL(urlValue);
    const affId = url.searchParams.get(QUERY_PARAMS.PARTNER_KEY);
    const offerId = url.searchParams.get(QUERY_PARAMS.PARTNER_OFFER_ID);
    const affOfferId = url.searchParams.get(QUERY_PARAMS.PARTNER_AFF_OFFER_ID);
    const resolvedOfferId = offerId || affOfferId;

    if (!affId || !resolvedOfferId) {
      return null;
    }

    return { affId, offerId: resolvedOfferId };
  } catch {
    return null;
  }
};
